export default __webpack_public_path__ + "static/media/ic-report.7891ff4d.svg";